import { render, staticRenderFns } from "./BackgroundArticle.vue?vue&type=template&id=c7ea0e44&"
import script from "./BackgroundArticle.vue?vue&type=script&lang=ts&"
export * from "./BackgroundArticle.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports